/**
 * 简单 LRU Cache，用于缓存消息渲染结果
 */
export class LRUCache {
  constructor(maxSize = 500) {
    this.maxSize = maxSize
    this.cache = new Map()
  }
  get(key) {
    if (!this.cache.has(key)) return undefined
    const val = this.cache.get(key)
    // 访问后移到末尾
    this.cache.delete(key)
    this.cache.set(key, val)
    return val
  }
  set(key, val) {
    if (this.cache.has(key)) this.cache.delete(key)
    else if (this.cache.size >= this.maxSize) {
      // 删除最旧的
      this.cache.delete(this.cache.keys().next().value)
    }
    this.cache.set(key, val)
  }
  has(key) { return this.cache.has(key) }
  clear() { this.cache.clear() }
}

export const msgHtmlCache = new LRUCache(1000)
